import Faye from 'faye'

const socket = new Faye.Client(ENV.WS_URL)

export { socket }
